import ReactDOM from 'react-dom/client';
import AppRouter from './AppRouter';
import { AlertProvider } from './Components/AlertContext';
import './index.css';
import { AppProviders } from './providers/AppProviders';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <AppProviders>
    <AlertProvider>
      <AppRouter />
    </AlertProvider>
  </AppProviders>,
);
